<template>
  <div class="wdqb-box" v-if="data">
    <div class="wdqb-content">
      <!-- 左侧：钱包信息 -->
      <div class="wdqb-left">
        <!-- 币种卡片 -->
        <div class="wdqb-coin-card">
		  <img :src="data.currencyLogo" alt="" class="wdqb-coin-icon"/>
          <div class="wdqb-coin-info">
            <span class="wdqb-coin-name">{{data.unitText}}</span>
            <span class="wdqb-coin-desc">{{$t('all.lianshangbaobishibei')}}</span>
          </div>
        </div>
        <!-- 余额信息 -->
        <div class="wdqb-item">
          <span class="wdqb-item-label">{{$t('all.zonge')}}</span>
          <span class="wdqb-item-value">{{data.sumAmount}} {{data.unitText}}</span>
        </div>
        <div class="wdqb-item">
          <span class="wdqb-item-label">{{$t('all.keyongshuliang')}}</span>
          <span class="wdqb-item-value">{{data.sumAvailableAmount}} {{data.unitText}}</span>
        </div>
        <div class="wdqb-item">
          <span class="wdqb-item-label">{{$t('all.dongjieshuliang')}}</span>
          <span class="wdqb-item-value">{{data.sumFreezeAmount}} {{data.unitText}}</span>
        </div>
        <!-- 操作按钮 -->
        <div class="wdqb-actions">
          <div :class="activeTab === 'deposit' ? 'wdqb-action-btn wdqb-action-gradient' : 'wdqb-action-btn'" @click="activeTab = 'deposit'">{{$t('all.chongbi')}}</div>
          <div :class="activeTab === 'withdraw' ? 'wdqb-action-btn wdqb-action-gradient' : 'wdqb-action-btn'" @click="activeTab = 'withdraw'">{{$t('all.tibi')}}</div>
        </div>
        <!-- 查看流水 -->
        <div class="wdqb-flow-btn" @click="handleGoFlow">{{$t('all.chakanliushui')}}</div>
      </div>
      <!-- 右侧面板 -->
      <div class="wdqb-right">
        <!-- 充币面板 -->
        <template v-if="activeTab === 'deposit'">
          <div class="wdqb-right-item">
            <span class="wdqb-right-label">{{$t('all.dizhi')}}</span>
            <div class="wdqb-right-item-right">
              <span class="wdqb-right-value wdqb-text-green">{{formatAddress(data.rechargeAddress)}}</span>
              <img src="../../../assets/image/fuzhi_18@2x.png" alt="" @click="handleCopyAddress"/>
            </div>
          </div>
          <div class="wdqb-right-item">
            <span class="wdqb-right-label">{{$t('all.wangluo')}}</span>
            <span class="wdqb-right-value wdqb-text-green">{{data.currencyName}}</span>
          </div>
          <div class="wdqb-right-tip">{{$t('all.chongzhitip')}}</div>
          <div class="wdqb-right-item">
            <span class="wdqb-right-label">{{$t('all.chongzhishuliang')}}</span>
            <input class="wdqb-right-input" v-model="depositAmount" :placeholder="$t('all.shuru')" />
          </div>
          <div class="wdqb-right-estimate">
            <span class="wdqb-right-estimate-title">{{$t('all.yujidaozhang')}}</span>
            <div class="wdqb-right-estimate-card">
              <span class="wdqb-right-estimate-label">{{$t('all.shijidaozhang')}}</span>
              <span class="wdqb-right-estimate-num">99.00 NB</span>
            </div>
            <div class="wdqb-right-estimate-info">
              <span>{{$t('all.chongzhishuliang')}} 100.00 NB</span>
              <span>{{$t('all.shouxufei')}} 1.00 NB (1%)</span>
            </div>
          </div>
          <div class="wdqb-right-btn" @click="handleRecharge">{{$t('all.lijichongzhi')}}</div>
        </template>
        <!-- 提币面板 -->
        <template v-if="activeTab === 'withdraw'">
          <div class="wdqb-right-item">
            <span class="wdqb-right-label">{{$t('all.tibidizhi')}}</span>
            <div class="wdqb-right-item-right">
              <span class="wdqb-right-value wdqb-text-green">{{formatAddress(data.rechargeAddress)}}</span>
              <img src="../../../assets/image/jinru_14@2x.png" alt=""/>
            </div>
          </div>
          <div class="wdqb-right-item">
            <span class="wdqb-right-label">{{$t('all.wangluo')}}</span>
            <span class="wdqb-right-value">{{data.currencyName}}</span>
          </div>
          <div class="wdqb-right-item">
            <span class="wdqb-right-label">{{$t('all.tibishuliang')}}</span>
            <input class="wdqb-right-input" v-model="withdrawAmount" :placeholder="$t('all.qingshuru')" />
          </div>
          <div class="wdqb-right-error" v-if="withdrawError">{{withdrawError}}</div>
          <div class="wdqb-right-estimate">
            <div class="wdqb-right-estimate-header">
              <span class="wdqb-right-estimate-title">{{$t('all.tibishisuan')}}</span>
              <span class="wdqb-right-estimate-tag">{{$t('all.shouxufeibilv')}}{{data.withdrawalServiceChargeRatio}}</span>
            </div>
            <div class="wdqb-right-estimate-row">
              <span>{{$t('all.shouxufei')}}</span>
              <span>{{withdrawFee}} {{data.unitText}}</span>
            </div>
            <div class="wdqb-right-estimate-row">
              <span>{{$t('all.shijidaozhang')}}</span>
              <span class="wdqb-text-green">{{withdrawActual}} {{data.unitText}}</span>
            </div>
          </div>
          <div class="wdqb-right-btn" @click="handleWithdraw">{{$t('all.tijiaotibi')}}</div>
        </template>
      </div>
    </div>

    <!-- 选择提币地址弹框 -->
    <div class="wdqb-overlay" v-if="showAddressModal" @click="showAddressModal = false"></div>
    <div class="wdqb-address-modal" v-if="showAddressModal" @click.stop>
      <div class="wdqb-address-title">{{$t('all.xuanzetibidizhi')}}</div>
      <div class="wdqb-address-search">
		<img class="wdqb-address-search-icon" src="../../../assets/image/sousuo_18@2x.png" alt=""/>
        <input class="wdqb-address-search-input" v-model="searchAddress" :placeholder="$t('all.sousuodizhi')" />
      </div>
      <div class="wdqb-address-list">
        <div class="wdqb-address-item" v-for="(item, index) in addressList" :key="index">
          <div class="wdqb-address-item-info">
            <span class="wdqb-address-item-label">{{item.label}}</span>
            <span class="wdqb-address-item-value">{{item.address}}</span>
          </div>
          <div class="wdqb-address-item-btn" @click="handleSelectAddress(item)">{{$t('all.xuanze')}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserWalletInfo,toWithdrawal } from "@/api/qianbao";
export default {
  data() {
    return {
	  data:'',
      activeTab: 'deposit',
      showAddressModal: false,
      searchAddress: '',
      addressList: [
        { label: '常用地址', address: '0x82...8F91' },
        { label: '交易所地址', address: '0x82...8F91' },
        { label: '冷钱包', address: '0x82...8F91' },
      ],
      depositAmount: '',
      withdrawAmount: '',
      withdrawFee: '0.00',
      withdrawActual: '0.00',
      withdrawError: ''
    };
  },
  mounted() {
  	this.getUserWalletInfo()
  },
  watch: {
    withdrawAmount(val) {
      this.calculateWithdraw(val);
    }
  },
  methods: {
	async getUserWalletInfo(){
	  const res = await getUserWalletInfo({currencyId:this.$route.query.currencyId})
	  this.data = res.data
	  console.log('wallet data:', this.data)
	  console.log('fee ratio:', this.data.withdrawalServiceChargeRatio)
	},
    calculateWithdraw(val) {
      this.withdrawError = '';
      this.withdrawFee = '0.00';
      this.withdrawActual = '0.00';

      if (!val || parseFloat(val) <= 0) {
        return;
      }

      const amount = parseFloat(val);
      const minAmount = parseFloat(this.data.minWithdrawalAmount || 0);
      const maxAmount = parseFloat(this.data.maxWithdrawalAmount || -1);
      const availableAmount = parseFloat(this.data.sumAvailableAmount || 0);
      const feeRatio = parseFloat(this.data.withdrawalServiceChargeRatio || 0);

      if (amount < minAmount) {
        this.withdrawError = this.$t('all.zuiditixianjin') + minAmount + ' ' + this.data.unitText;
        return;
      }

      if (maxAmount !== -1 && amount > maxAmount) {
        this.withdrawError = this.$t('all.meiriyushutixian') + maxAmount + ' ' + this.data.unitText;
        return;
      }

      if (amount > availableAmount) {
        this.withdrawError = this.$t('all.keyongyu') + availableAmount + ' ' + this.data.unitText;
        return;
      }

      const fee = amount * feeRatio;
      const actual = amount - fee;

      this.withdrawFee = this.truncateDecimal(fee);
      this.withdrawActual = this.truncateDecimal(actual);
    },
    truncateDecimal(num) {
      const str = Number(num).toFixed(10);
      const decimalIndex = str.indexOf('.');
      if (decimalIndex === -1) {
        return str + '.00';
      }
      const integerPart = str.slice(0, decimalIndex);
      const decimalPart = str.slice(decimalIndex + 1, decimalIndex + 3);
      return integerPart + '.' + (decimalPart.padEnd(2, '0'));
    },
    handleGoFlow() {
      this.$router.push({ path: '/liushuijilu',query: {
        currencyId: this.data.currencyId,
        unitText:this.data.unitText
      }});
    },
    handleCopyAddress() {
      navigator.clipboard.writeText('0x82...8F91');
      this.$message.success(this.$t('all.fuzhichenggong'));
    },
    handleRecharge() {
      this.$router.push('/chongzhierweima');
    },
    async handleWithdraw() {
	  const res = await toWithdrawal({
		  currencyId:this.data.currencyId,
		  amount:this.withdrawAmount
	  })
	  this.$message.success(res.msg);
	  this.getUserWalletInfo()
      // this.showAddressModal = true;
    },
    handleSelectAddress(item) {
      this.showAddressModal = false;
      this.$router.push('/querentbi');
    },
    formatAddress(address) {
      if (!address) return '';
      if (address.length <= 10) return address;
      return address.slice(0, 6) + '...' + address.slice(-4);
    }
  }
};
</script>

<style scoped lang="scss">
@import "./wodequanbao.css";
</style>



// WEBPACK FOOTER //
// wodequanbao.vue?18bfcdd4